import { Map } from 'immutable'
export default function stubImmutableMap() {
  return Map({})
}
